import React from 'react'
import AddLoanPermissionModal, { openAddLoanPermissionsModal } from './AddLoanPermissionModal'
import DeleteLoanPermissionModal, { openDeleteLoanPermissionModal } from './DeleteLoanPermissionModal'

const Modals = ({ permissions, onRefresh }) => (
  <div>
    {/* @ts-ignore */}
    <AddLoanPermissionModal addedPermissions={permissions} onRefresh={onRefresh} />
    <DeleteLoanPermissionModal onRefresh={onRefresh} />
  </div>
)

export { openAddLoanPermissionsModal, openDeleteLoanPermissionModal }

export default Modals
